import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  DispatchIssueCausedByWithCache,
  MutationUpdateDispatchIssueCausedByBulkArgs,
  UpdateDispatchIssueCausedByBulkResponse,
  UpdateDispatchIssueCausedByInput,
  UpdateDispatchIssueCausedByValuesInput,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';
import { getProperty, queryInput } from '@/utils';

import { TypedDocumentNode } from '@apollo/client';
import { UpdateDispatchIssueCausedBy } from '@/features/IssueHistory/api/queries/UpdateDispatchIssueCausedBy';
import graphApi from '@/api';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof DispatchIssueCausedByWithCache]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<UpdateDispatchIssueCausedByBulkResponse>;
}

// UpdateDispatchIssueCausedBy Service
export const { updateDispatchIssueCausedBy, useUpdateDispatchIssueCausedBy } = ((): {
  updateDispatchIssueCausedBy: ServiceMethod;
  useUpdateDispatchIssueCausedBy: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(UpdateDispatchIssueCausedBy).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (
        payload?: Partial<UpdateDispatchIssueCausedByValuesInput & { id: string }>[],
        options?: ConnectionOptions
      ): Promise<UpdateDispatchIssueCausedByBulkResponse> => {
        debug.log('updateDispatchIssueCausedBy,updateDispatchIssueCausedBy.input', 'INPUT', payload);
        const updates: UpdateDispatchIssueCausedByInput[] =
          payload
            ?.filter(({ id }) => id)
            ?.map(
              ({ id, ...value }): UpdateDispatchIssueCausedByInput => ({
                query: [
                  {
                    id: queryInput(id),
                  },
                ],
                value: {
                  causedById: value?.causedById || null,
                  dispatchIssueId: value?.dispatchIssueId || null,
                },
              })
            ) ?? [];
        const args: MutationUpdateDispatchIssueCausedByBulkArgs = {
          input: {
            updates,
          },
        };
        debug.log('updateDispatchIssueCausedBy,updateDispatchIssueCausedBy.payload', 'PAYLOAD', args);
        const opts = { merge: options?.merge ? 'updateDispatchIssueCausedByBulk' : undefined };
        const res = await fn(args, opts);
        debug.log('updateDispatchIssueCausedBy,updateDispatchIssueCausedBy.response', 'RESPONSE', res);
        return getProperty('updateDispatchIssueCausedByBulk', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    updateDispatchIssueCausedBy: fetch,
    useUpdateDispatchIssueCausedBy: useService,
  };
})();
